var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "alerts" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("nav", { staticClass: "navbar fixted-top navbar-light bg-light" }, [
        _c("div", { staticClass: "navbar-brand" }, [_vm._v("Alerts")]),
        _vm._v(" "),
        _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: { active: _vm.view === "summary" },
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.view = "summary"
                  }
                }
              },
              [_vm._v("summary")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: { active: _vm.view === "all" },
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.view = "all"
                  }
                }
              },
              [_vm._v("all alerts")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-primary",
            staticStyle: { float: "right", cursor: "pointer" },
            attrs: { type: "button" },
            on: { click: _vm.downloadCSV }
          },
          [_vm._v("Download Report")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("MetricGraph", {
              attrs: {
                metrics: _vm.metrics,
                name: "Total Alerts",
                date: _vm.date,
                period: _vm.period,
                lastUpdate: _vm.lastUpdate,
                metricProperties: _vm.metricProperties,
                metricProperty: _vm.metricProperty
              },
              on: { updateMetric: _vm.updateMetric }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _vm.loaded
            ? _c(
                "div",
                { attrs: { id: "timeline" } },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-body",
                          staticStyle: { padding: "0" }
                        },
                        [
                          _c("AlertPriorityCount", {
                            attrs: {
                              labels: _vm.labels,
                              critical: _vm.timeline.P1,
                              downgraded: _vm.timeline.P2,
                              warning: _vm.timeline.P4,
                              task: _vm.timeline.P3,
                              informational: _vm.timeline.P5
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.view === "all"
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c(
                      "div",
                      { staticClass: "table-margin" },
                      [
                        _c(
                          "vue-good-table",
                          {
                            attrs: {
                              columns: _vm.alertColumns,
                              rows: _vm.alertRows(),
                              "search-options": {
                                enabled: true,
                                skipDiacritics: true,
                                placeholder: "filter alerts"
                              },
                              "pagination-options": {
                                enabled: true,
                                perPage: 50,
                                position: "top"
                              },
                              styleClass: "vgt-table condensed"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "emptystate" },
                                slot: "emptystate"
                              },
                              [
                                _vm._v(
                                  "\n                No alerts\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ])
        : _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "column" }, [
                _vm.loaded
                  ? _c(
                      "div",
                      { staticClass: "uptime", attrs: { id: "uptime" } },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade", appear: "" } },
                          [
                            _c("Uptime", {
                              attrs: {
                                alerts: _vm.allAlerts,
                                downtime: _vm.downtime
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "column" }, [
                _vm.alertsLoaded
                  ? _c(
                      "div",
                      { attrs: { id: "timeline" } },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade", appear: "" } },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "card-heading",
                                  staticStyle: { "padding-left": "15px" }
                                },
                                [
                                  _c("h5", { staticClass: "card-title" }, [
                                    _vm._v("Timeline (UTC)")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "card-body",
                                  staticStyle: { padding: "0" }
                                },
                                [
                                  _c("AlertTimeline", {
                                    attrs: {
                                      period: _vm.period,
                                      date: _vm.date,
                                      alerts: _vm.allAlerts
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "column" }, [
                _vm.loaded && _vm.incidents.length > 0
                  ? _c(
                      "div",
                      { staticClass: "incidents", attrs: { id: "incidents" } },
                      [
                        _c("Incidents", { attrs: { incidents: _vm.incidents } })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _vm.loaded && Object.keys(_vm.alerts).length > 0
                  ? _c(
                      "div",
                      { staticClass: "alerts", attrs: { id: "alerts" } },
                      [
                        _c("AlertsPriorityList", {
                          attrs: { alerts: _vm.alerts }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de6edc5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de6edc5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Alerts.vue
// module id = null
// module chunks = 